/**
 * Robotmyggen AI-assistent — embed-widget
 * ---------------------------------------------------------------
 * Sæt dette script ind på siden (theme.liquid i Shopify, eller i
 * Min Have-appens HTML), og angiv config FØR scriptet indlæses:
 *
 *   <script>
 *     window.ROBOTMYGGEN_WIDGET_CONFIG = {
 *       workerUrl: "https://DIT-WORKER-NAVN.DIN-KONTO.workers.dev/",
 *       channel: "webshop" // eller "app" inde i Min Have
 *     };
 *   </script>
 *   <script src="robotmyggen-widget.js"></script>
 *
 * Se opsætningsguide.md for de fulde trin.
 */
(function () {
  "use strict";

  var config = window.ROBOTMYGGEN_WIDGET_CONFIG || {};
  var WORKER_URL = config.workerUrl || "";
  var CHANNEL = config.channel === "app" ? "app" : "webshop";
  var STORAGE_KEY = "robotmyggen_chat_" + CHANNEL;

  // Chat-knappens ikon: myggen fra logoet. Billedet ligger som robotmyggen-ikon.webp
  // ved siden af dette script (kan overstyres med iconUrl i config).
  var ICON_URL = config.iconUrl || (function () {
    try {
      var src = document.currentScript && document.currentScript.src;
      if (src && /robotmyggen-widget\.js(\?.*)?$/.test(src)) {
        return src.replace(/robotmyggen-widget\.js(\?.*)?$/, "robotmyggen-ikon.webp");
      }
    } catch (e) {}
    return "";
  })();

  if (!WORKER_URL) {
    console.warn("[Robotmyggen widget] Mangler workerUrl i window.ROBOTMYGGEN_WIDGET_CONFIG — widget starter ikke.");
    return;
  }

  // ---------------- Fonte (valgfrit — falder pænt tilbage hvis det ikke kan hentes) ----------------
  try {
    var fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = "https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@700;800&family=IBM+Plex+Sans:wght@400;500;600&display=swap";
    document.head.appendChild(fontLink);
  } catch (e) {}

  // ---------------- Styles ----------------
  var style = document.createElement("style");
  style.textContent = [
    "#rm-widget-root{position:fixed;bottom:20px;right:20px;z-index:999999;font-family:'IBM Plex Sans',ui-sans-serif,system-ui,sans-serif;}",
    "#rm-widget-root *{box-sizing:border-box;}",
    "#rm-launcher{width:58px;height:58px;border-radius:50%;background:#1F4732;color:#E9F2EC;border:none;box-shadow:0 4px 16px rgba(0,0,0,0.2);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;overflow:hidden;}",
    "#rm-launcher svg{width:28px;height:28px;}",
    "#rm-launcher img{width:100%;height:100%;display:block;border-radius:50%;pointer-events:none;}",
    "#rm-panel{position:fixed;bottom:90px;right:20px;width:360px;max-width:calc(100vw - 32px);height:520px;max-height:calc(100vh - 120px);background:#FFFFFF;border-radius:16px;box-shadow:0 8px 32px rgba(0,0,0,0.25);display:none;flex-direction:column;overflow:hidden;border:1px solid #D8E0D3;transition:bottom 0.15s ease, height 0.15s ease;}",
    "#rm-panel.open{display:flex;}",
    "#rm-header{background:#1F4732;color:#E9F2EC;padding:14px 16px;font-family:'Big Shoulders Display',sans-serif;font-weight:800;font-size:18px;display:flex;align-items:center;justify-content:space-between;}",
    "#rm-close{background:none;border:none;color:#E9F2EC;font-size:20px;cursor:pointer;line-height:1;padding:4px;}",
    "#rm-log{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px;background:#F1F4EE;}",
    ".rm-msg{max-width:85%;padding:9px 12px;border-radius:12px;font-size:13.5px;line-height:1.45;white-space:pre-wrap;}",
    ".rm-msg.agent{align-self:flex-start;background:#FFFFFF;border:1px solid #D8E0D3;border-bottom-left-radius:3px;color:#16241C;}",
    ".rm-msg.user{align-self:flex-end;background:#1F4732;color:#E9F2EC;border-bottom-right-radius:3px;}",
    "#rm-form{display:flex;gap:8px;padding:10px;border-top:1px solid #D8E0D3;background:#FFFFFF;}",
    "#rm-input{flex:1;resize:none;border:1px solid #D8E0D3;border-radius:10px;padding:8px 10px;font:inherit;font-size:13.5px;max-height:80px;}",
    "#rm-send{background:#1F4732;color:#E9F2EC;border:none;border-radius:10px;padding:8px 14px;font-weight:600;font-size:13px;cursor:pointer;}",
    "#rm-send:disabled{opacity:0.5;cursor:default;}",
    "@media (max-width:480px){#rm-panel{right:16px;left:16px;width:auto;height:min(520px,70vh);}}",
    // Vejledning ved ikonet: fast label + velkomstboble + diskret puls
    "#rm-label{position:absolute;right:68px;bottom:11px;display:flex;align-items:center;gap:7px;background:#FFFFFF;color:#1F4732;border:1px solid #D8E0D3;border-radius:999px;padding:9px 14px;font-family:inherit;font-size:13.5px;font-weight:600;line-height:1.2;white-space:nowrap;box-shadow:0 4px 14px rgba(0,0,0,0.15);cursor:pointer;}",
    "#rm-label .rm-dot{width:8px;height:8px;border-radius:50%;background:#5FAF4B;box-shadow:0 0 0 3px rgba(95,175,75,0.25);flex:none;}",
    "#rm-teaser{position:absolute;right:0;bottom:74px;width:270px;background:#FFFFFF;color:#16241C;border:1px solid #D8E0D3;border-radius:14px;padding:14px 34px 14px 14px;box-shadow:0 8px 28px rgba(0,0,0,0.18);font-size:13.5px;line-height:1.45;opacity:0;visibility:hidden;transform:translateY(8px);transition:opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;}",
    "#rm-teaser.show{opacity:1;visibility:visible;transform:none;}",
    "#rm-teaser:after{content:'';position:absolute;right:22px;bottom:-7px;width:12px;height:12px;background:#FFFFFF;border-right:1px solid #D8E0D3;border-bottom:1px solid #D8E0D3;transform:rotate(45deg);}",
    "#rm-teaser strong{display:block;font-family:'Big Shoulders Display',sans-serif;font-size:18px;font-weight:800;color:#1F4732;margin-bottom:4px;line-height:1.15;}",
    "#rm-teaser-close{position:absolute;top:6px;right:6px;background:none;border:none;color:#5B6B60;font-size:20px;line-height:1;cursor:pointer;padding:4px 6px;}",
    "#rm-teaser-start{display:inline-block;margin-top:10px;background:#1F4732;color:#E9F2EC;border:none;border-radius:10px;padding:8px 14px;font-family:inherit;font-weight:600;font-size:13px;cursor:pointer;}",
    "#rm-pulse{position:absolute;right:0;bottom:0;width:58px;height:58px;border-radius:50%;pointer-events:none;animation:none;}",
    "@keyframes rm-pulse{0%{box-shadow:0 0 0 0 rgba(95,175,75,0.6);}100%{box-shadow:0 0 0 18px rgba(95,175,75,0);}}",
    "#rm-widget-root.is-open #rm-label,#rm-widget-root.is-open #rm-teaser,#rm-widget-root.is-open #rm-pulse{display:none;}",
    "@media (max-width:480px){#rm-label{font-size:13px;padding:8px 12px;bottom:12px;}#rm-teaser{width:min(270px,calc(100vw - 40px));}}",
    "@media (prefers-reduced-motion:reduce){#rm-pulse{animation:none;}#rm-teaser{transition:none;}}",
  ].join("\n");
  style.textContent += "#rm-panel{bottom:110px;}#rm-launcher{width:76px;height:76px;background:#fff;border:2px solid #d8e0d3;overflow:visible;isolation:isolate;}#rm-launcher img{object-fit:contain;transform-origin:50% 80%;border-radius:0;}#rm-label{right:86px;bottom:20px;}#rm-teaser{bottom:94px;}#rm-widget-root.rm-greeting #rm-launcher img{animation:rm-mascot-hello 1.8s ease-in-out 2;}@keyframes rm-mascot-hello{0%,100%{transform:translateY(0) rotate(0);}20%{transform:translateY(-12px) rotate(-9deg);}40%{transform:translateY(0) rotate(7deg);}60%{transform:translateY(-6px) rotate(-5deg);}80%{transform:translateY(0) rotate(3deg);}}body:has(.rm-filter-drawer>details[open]) #rm-widget-root{visibility:hidden;pointer-events:none;}@media(max-width:480px){#rm-widget-root{bottom:16px;right:16px;}#rm-launcher{width:64px;height:64px;}#rm-label{right:74px;bottom:16px;max-width:calc(100vw - 110px);white-space:normal;text-align:left;}#rm-teaser{bottom:82px;}}@media(prefers-reduced-motion:reduce){#rm-widget-root.rm-greeting #rm-launcher img{animation:none!important;}}";
  document.head.appendChild(style);

  // ---------------- Vejledende tekster ved ikonet ----------------
  var HINTS = {
    webshop: {
      label: "Spørg AI-assistenten",
      title: "I tvivl om din robot? 🌿",
      text: "Spørg mig – jeg hjælper med robotvalg, service og vinteropbevaring.",
      cta: "Spørg mig",
    },
    app: {
      label: "Spørg AI-supporten",
      title: "Brug for hjælp?",
      text: "Spørg mig om service, vinteropbevaring eller fejlfinding på din robot.",
      cta: "Start chat",
    },
  };
  var HINT = HINTS[CHANNEL];
  var TEASER_KEY = "robotmyggen_teaser_vist_" + CHANNEL;

  // ---------------- Markup ----------------
  var CHAT_SVG = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16v12H8l-4 4V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  var LAUNCHER_ICON = ICON_URL ? '<img src="' + ICON_URL + '" alt="" width="58" height="58">' : CHAT_SVG;
  var root = document.createElement("div");
  root.id = "rm-widget-root";
  root.innerHTML =
    '<div id="rm-teaser" role="status">' +
    '<button id="rm-teaser-close" type="button" aria-label="Luk besked">&times;</button>' +
    "<strong>" + HINT.title + "</strong>" +
    HINT.text +
    '<br><button id="rm-teaser-start" type="button">' + HINT.cta + "</button>" +
    "</div>" +
    '<button id="rm-label" type="button"><span class="rm-dot"></span>' + HINT.label + "</button>" +
    '<span id="rm-pulse" aria-hidden="true"></span>' +
    '<button id="rm-launcher" aria-label="Åbn chat">' +
    LAUNCHER_ICON +
    "</button>" +
    '<div id="rm-panel">' +
    '<div id="rm-header"><span>Robotmyggen Assistent</span><button id="rm-close" aria-label="Luk">&times;</button></div>' +
    '<div id="rm-log"></div>' +
    '<form id="rm-form">' +
    '<textarea id="rm-input" rows="1" placeholder="Skriv en besked…"></textarea>' +
    '<button id="rm-send" type="submit">Send</button>' +
    "</form>" +
    "</div>";
  document.body.appendChild(root);

  var launcher = root.querySelector("#rm-launcher");
  var panel = root.querySelector("#rm-panel");
  var closeBtn = root.querySelector("#rm-close");
  var log = root.querySelector("#rm-log");
  var form = root.querySelector("#rm-form");
  var input = root.querySelector("#rm-input");
  var sendBtn = root.querySelector("#rm-send");

  // Kan billedet ikke hentes, vises den gamle taleboble i stedet
  var launcherImg = launcher.querySelector("img");
  if (launcherImg) {
    launcherImg.addEventListener("error", function () {
      launcher.innerHTML = CHAT_SVG;
    });
  }

  var GREETINGS = {
    webshop: "Hej! Jeg er Robotmyggens kunderådgiver 🌱 Fortæl mig om din have (størrelse, skråninger, forhindringer) og dit budget, så anbefaler jeg den rigtige robotplæneklipper.",
    app: "Hej og velkommen til Min Have-support. Hvad kan jeg hjælpe med — service, vinteropbevaring, fejlfinding på din robot, eller noget andet?",
  };

  var history = loadHistory();

  function loadHistory() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return [];
  }

  function saveHistory() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    } catch (e) {}
  }

  function renderAll() {
    log.innerHTML = "";
    if (history.length === 0) {
      addMessage("agent", GREETINGS[CHANNEL], false);
    } else {
      history.forEach(function (m) {
        addMessage(m.role === "user" ? "user" : "agent", m.content, false);
      });
    }
  }

  function addMessage(role, text, push) {
    var el = document.createElement("div");
    el.className = "rm-msg " + role;
    el.textContent = text;
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    if (push) {
      history.push({ role: role === "user" ? "user" : "assistant", content: text });
      saveHistory();
    }
    return el;
  }

  var teaser = root.querySelector("#rm-teaser");
  var label = root.querySelector("#rm-label");

  function hideTeaser() {
    root.classList.remove("rm-greeting");
    teaser.classList.remove("show");
  }

  function setOpen(open) {
    panel.classList.toggle("open", open);
    root.classList.toggle("is-open", open);
    if (open) {
      hideTeaser();
      input.focus();
    }
  }

  launcher.addEventListener("click", function () {
    setOpen(!panel.classList.contains("open"));
  });
  label.addEventListener("click", function () {
    setOpen(true);
  });
  root.querySelector("#rm-teaser-start").addEventListener("click", function () {
    setOpen(true);
  });
  root.querySelector("#rm-teaser-close").addEventListener("click", hideTeaser);
  closeBtn.addEventListener("click", function () {
    setOpen(false);
  });

  // Velkomstboblen vises én gang pr. besøg, kort efter siden er åbnet
  (function () {
    var seen = false;
    try {
      seen = sessionStorage.getItem(TEASER_KEY) === "1";
    } catch (e) {}
    if (seen || history.length > 0) return;
    setTimeout(function () {
      if (panel.classList.contains("open")) return;
      teaser.classList.add("show");
      root.classList.add("rm-greeting");
      setTimeout(function(){root.classList.remove("rm-greeting");}, 4000);
      try {
        sessionStorage.setItem(TEASER_KEY, "1");
      } catch (e) {}
      setTimeout(hideTeaser, 15000);
    }, 2500);
  })();

  // ---------------- Hold panelet synligt over mobil-tastaturet ----------------
  // Når skærmens tastatur åbnes på mobil, ændrer window.visualViewport sig
  // (bliver lavere / flyttes), men "position:fixed" følger ikke altid med.
  // Vi genberegner panelets bund og maks-højde, så header + input altid er synlige.
  function updatePanelForViewport() {
    if (!window.visualViewport) return;
    var vv = window.visualViewport;
    var keyboardGap = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    var launcherRect = launcher.getBoundingClientRect();
    var baseBottom = window.innerHeight - launcherRect.top + 12;
    panel.style.bottom = (baseBottom + keyboardGap) + "px";
    var available = vv.height - 20;
    panel.style.maxHeight = Math.max(260, available) + "px";
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", updatePanelForViewport);
    window.visualViewport.addEventListener("scroll", updatePanelForViewport);
  }
  input.addEventListener("focus", function () {
    setTimeout(updatePanelForViewport, 50);
    setTimeout(updatePanelForViewport, 300);
  });
  input.addEventListener("blur", function () {
    setTimeout(updatePanelForViewport, 50);
  });

  input.addEventListener("input", function () {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight, 80) + "px";
  });
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  });
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    handleSend();
  });

  var sending = false;
  function handleSend() {
    var text = input.value.trim();
    if (!text || sending) return;
    input.value = "";
    input.style.height = "auto";
    addMessage("user", text, true);
    askBackend();
  }

  function askBackend() {
    sending = true;
    sendBtn.disabled = true;
    var thinking = addMessage("agent", "Tænker …", false);

    fetch(WORKER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ channel: CHANNEL, messages: history }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || "Ukendt fejl");
          return data;
        });
      })
      .then(function (data) {
        thinking.textContent = data.reply || "Jeg fik desværre et tomt svar. Prøv igen.";
        history.push({ role: "assistant", content: thinking.textContent });
        saveHistory();
      })
      .catch(function (err) {
        thinking.textContent = "Der opstod desværre en fejl (" + err.message + "). Prøv igen om lidt, eller kontakt os direkte.";
      })
      .finally(function () {
        sending = false;
        sendBtn.disabled = false;
        log.scrollTop = log.scrollHeight;
      });
  }

  renderAll();
})();

